import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileMenu", "overlay"]

  connect() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll.bind(this))
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll.bind(this))
  }

  handleScroll() {
    // Get the actual nav element, not the wrapper div
    const navbar = this.element.querySelector('nav')
    if (!navbar) return
    
    const scrollPosition = window.scrollY
    
    // Change navbar style based on scroll position
    if (scrollPosition > 50) {
      navbar.classList.remove('bg-transparent')
      navbar.classList.add('bg-white', 'shadow-lg')
      
      // Update text colors
      navbar.querySelectorAll('[class*="text-white"]').forEach(el => {
        el.classList.remove('text-white')
        el.classList.add('text-content')
      })
      
      // Update logo
      const logo = navbar.querySelector('img')
      if (logo) {
        logo.classList.remove('brightness-0', 'invert')
      }
    } else {
      // Only on home page
      if (window.location.pathname === '/' || window.location.pathname === '') {
        navbar.classList.remove('bg-white', 'shadow-lg')
        navbar.classList.add('bg-transparent')
        
        // Update text colors
        navbar.querySelectorAll('[class*="text-content"]').forEach(el => {
          if (!el.closest('[data-scroll-navbar-target]')) {
            el.classList.remove('text-content')
            el.classList.add('text-white')
          }
        })
        
        // Update logo
        const logo = navbar.querySelector('img')
        if (logo) {
          logo.classList.add('brightness-0', 'invert')
        }
      }
    }
  }

  toggleMobile() {
    this.overlayTarget.classList.toggle('hidden')
    this.mobileMenuTarget.classList.toggle('translate-x-full')
    
    // Toggle body scroll
    if (this.mobileMenuTarget.classList.contains('translate-x-full')) {
      document.body.style.overflow = ''
    } else {
      document.body.style.overflow = 'hidden'
    }
  }

  closeMobile() {
    this.overlayTarget.classList.add('hidden')
    this.mobileMenuTarget.classList.add('translate-x-full')
    document.body.style.overflow = ''
  }
}